import Vue from 'vue'
import Vuex from 'vuex'
import queryString from 'query-string'
import { RootState } from './types'

// importing a vuex module
import play from './modules/play'

Vue.use(Vuex)

console.log(queryString.parse(document.location.search))

const state: RootState = {
  query: queryString.parse(document.location.search),
}

export default new Vuex.Store({
  state,
  mutations: {
  },
  actions: {
  },
  modules: {
    play,
  },
})
